import axios from "axios";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { translateMessage } from "src/app/methods/translateMessage";
import { RemoveModal } from "src/app/modals/RemoveModal/RemoveModal";
import { getProjectAudienceOverlap } from "src/redux";
import { API_URLS } from "src/utils/API_URLS";
import { showErrorToast } from "src/utils/methods";

interface Props {
  onClose: () => void;
}

const ClearAudienceOverlapModal = (props: Props) => {
  const { onClose } = props;

  const [loading, setLoading] = useState(false);

  const { projectId } = useParams<{ projectId: string }>();
  const dispatch = useDispatch();
  const intl = useIntl();

  const clearAO = async () => {
    try {
      setLoading(true);
      await axios.get(
        API_URLS.clearProjectAudienceOverlap.replace(
          ":projectUuid:",
          projectId,
        ),
      );
      dispatch(getProjectAudienceOverlap(projectId));
    } catch (err) {
      showErrorToast();
    } finally {
      setLoading(false);
    }
  };

  return (
    <RemoveModal
      onClose={onClose}
      objectNames={[
        translateMessage({
          intl,
          id: "ws_audience_overlap_analysis",
          defaultMessage: "Audience overlap analysis",
        }),
      ]}
      removeFunction={clearAO}
      loading={loading}
      hideWarningMessage
    />
  );
};

export default ClearAudienceOverlapModal;
